import { render, staticRenderFns } from "./ys-cell-goup.vue?vue&type=template&id=3385c15a&scoped=true&"
import script from "./ys-cell-goup.vue?vue&type=script&lang=js&"
export * from "./ys-cell-goup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../ys_expert-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3385c15a",
  null
  
)

export default component.exports